<template>
  <mini-card :value="$store.getters.totalLeadsClosed" subtitle="Leads Closed"
              :previousValue="$store.getters.totalLeadsClosedPrevious"
              :received="$store.getters.totalLeads"
              :previousReceived="$store.getters.totalLeadsPrevious">
    <div slot="header" class="icon-warning">
      <i class="fad fa-box-check text-success"></i>
    </div>
    <template slot="footer">
      <div class="row small ml-0">
        <span><i class="far fa-clock mr-2"/>Last closed: &nbsp;<i>{{lastClosedDate}}</i></span>
      </div>
    </template>
  </mini-card>
</template>

<script>
import MiniCard from './MiniCard.vue'
import utils from '../../utils'
export default {
    name: 'Leads-Closed-MiniCard',
    components: {
      MiniCard
    },
    data () {
      return {}
    },
    methods: {
      close () {
        this.$store.dispatch('openModal', {mode: 'Close', name: 'Lead'/* , object: new Lead({status: Lead._status.CLOSED.value}) */})
      },
      lost () {
        this.$store.dispatch('openModal', {mode: 'Lost', name: 'Lead'/* , object: new Lead({status: Lead._status.LOST.value}) */})
      }
    },
    computed: {
      lastClosedDate () {
        // we find the most recently received lead
        const leads = this.$store.getters.leads
        let date = new Date(0)
        if (leads && leads.length > 0) {
          leads.forEach(lead => {
            if (!lead.archived
                && lead.status == this.$store.getters.Lead._status.CLOSED.value
                && lead.dateClosed && lead.dateClosed.getTime() > date.getTime()) {
                  date = lead.dateClosed
            }
          })
          if (date.getTime() > 0) {
            return utils.dateToString(date)
          }
        }
        return '-'
      }
    }
}
</script>

<style>

</style>